import { Component } from '@angular/core';

@Component({
  selector: 'common-instagram-preview-icon',
  templateUrl: './instagram-preview-icon.component.svg',
  styleUrls: ['./instagram-preview-icon.component.scss'],
})
export class InstagramPreviewIconComponent {}
